import { render } from "./TransactionRefInput.vue?vue&type=template&id=708e4aa4"
import script from "./TransactionRefInput.vue?vue&type=script&lang=js"
export * from "./TransactionRefInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__